import { useMemo } from 'react'

import { WorkflowTranslator } from 'src/translators'
import { useGetWorkflowsQuery } from 'src/types/generated'

export const useGetWorkflows = () => {
  const { loading, data, refetch } = useGetWorkflowsQuery()

  return {
    workflows: useMemo(() => (data ? WorkflowTranslator.toEntities(data?.workflows) : []), [data]),
    loading,
    refetch,
  }
}
